export const TITLE = "TelepagosAdmin";
export const loaderColor = "#f29525";